import { environment } from '../../environments'
import { openWindow } from '../../services/container'

export const openCustomerSupportWindow = (): void => {
  openWindow(environment().supportUrl, 'get-support', { saveSizeAndPosition: true })
}
